import { useInfiniteQuery } from '@tanstack/react-query';

import { IProductsParams } from '@app/models/interfaces';
import Api from '@app/services/api';

export const useGetProductsQuery = ({ limit, category_id, tag_id, brand_id, q, ...params }: IProductsParams) => {
  return useInfiniteQuery({
    queryKey: ['getProducts', category_id, tag_id, brand_id, q],
    queryFn: async ({ pageParam = 0 }) => {
      return await Api.products.getProducts({ offset: pageParam, category_id, tag_id, brand_id, q, limit, ...params });
    },
    getNextPageParam: (current, allPages) => {
      const count = allPages.length * (limit || 1);
      return count >= (current.total || 0) ? undefined : count;
    },
  });
};
